import React from 'react';
import PropTypes from 'prop-types';

import useStyles from './styles';
import SecondaryButton from '../../../buttons/SecondaryButton';
import PrimaryButton from '../../../buttons/PrimaryButton';


const BasePickerComponent = ({
  title,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryClick,
  onSecondaryClick,
  children,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        {title}
      </div>
      <div className={classes.body}>
        {children}
      </div>
      <div className={classes.footer}>
        <SecondaryButton onClick={onSecondaryClick}>
          {secondaryButtonText}
        </SecondaryButton>
        <PrimaryButton onClick={onPrimaryClick}>
          {primaryButtonText}
        </PrimaryButton>
      </div>
    </div>
  );
};


BasePickerComponent.propTypes = {
  title: PropTypes.string.isRequired,
  primaryButtonText: PropTypes.string.isRequired,
  secondaryButtonText: PropTypes.string.isRequired,
  onPrimaryClick: PropTypes.func.isRequired,
  onSecondaryClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default BasePickerComponent;
